module.exports = __webpack_public_path__ + "r-v3/img/exam_mark_wrong.6098b429.svg";